/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconShield: {
  name: 'shield';
  data: string;
} = {
  name: 'shield',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M19.333 256.208c1.992 1.913 7.969 5.737 11.953 5.737v7.65c0 7.65-5.977 19.125-11.953 24.862-5.977-5.737-11.953-17.212-11.953-24.862v-7.65c3.985.001 9.961-3.824 11.953-5.737z" transform="matrix(15 0 0 15 16 -3824)"/></svg>`,
};
